import {
  Bubble,
  BubbleFilter,
  BubbleGrid,
  BubblePerson,
  FilterTranslation,
  PositionKey,
} from "./bubbleData";

const getGridData = (
  bubblePersonData: BubblePerson[],
  bubbleFilter: BubbleFilter[],
  bubbleCoordinates: BubbleGrid[]
): Bubble[] => {
  const numberOfPersons = bubblePersonData.length;
  const numberOfCoordinates = bubbleCoordinates.length;

  const mergedArray: Bubble[] = [];

  for (let i = 0; i < numberOfPersons; i++) {
    const coordinate = bubbleCoordinates[i % numberOfCoordinates];
    const person = bubblePersonData[i];

    if (isImageIcon(person?.imageSrc) && coordinate.size === "big") {
      const itemsToShuffle = mergedArray.filter(
        (item) => item?.imageSrc?.includes("VI_ikona") && item.size === "small"
      );

      if (itemsToShuffle.length > 0) {
        for (const shuffledItem of itemsToShuffle) {
          const index = mergedArray.findIndex((item) => item.size === "small");
          if (index !== -1) {
            mergedArray[index] = shuffledItem;
            break;
          }
        }
      }

      coordinate.size = "medium";
    }

    if (
      bubbleCoordinates[(i % numberOfCoordinates) + 1]?.size === "medium" &&
      bubbleCoordinates[(i % numberOfCoordinates) - 1]?.size === "medium"
    ) {
      coordinate.size = "big";
    }

    const mergedItem: Bubble = {
      ...person,
      ...coordinate,
    };

    mergedArray.push(mergedItem);

    if ((i + 1) % 3 === 0) {
      const bubbleFilterIndex = (i + 1) / 3 - 1;
      const filterItem = bubbleFilter[bubbleFilterIndex];
      mergedArray.push({ ...filterItem });
    }
  }
  return mergedArray;
};

const isImageIcon = (imageSrc: string | undefined) => {
  if (imageSrc) {
    const regex = /VI_ikona_/;
    return regex.test(imageSrc);
  }
  return false;
};

export const getBubblesCoordinates = (
  bubblePersonData: BubblePerson[],
  bubbleFilter: PositionKey | null,
  setBubbleFilter: React.Dispatch<React.SetStateAction<PositionKey | null>>,
  translation: FilterTranslation
): Bubble[] => {
  const bubbleFilterSmall: BubbleFilter[] = [
    {
      name: translation.dev,
      positionKey: PositionKey.Developer,
      onClick: (positionKey: PositionKey) => {
        setBubbleFilter(bubbleFilter === positionKey ? null : positionKey);
      },
      size: "small",
    },
    {
      name: translation.pm,
      positionKey: PositionKey.ProjectManager,
      onClick: (positionKey: PositionKey) => {
        setBubbleFilter(bubbleFilter === positionKey ? null : positionKey);
      },
      size: "small",
    },
    {
      name: translation.qa,
      positionKey: PositionKey.Tester,
      onClick: (positionKey: PositionKey) => {
        setBubbleFilter(bubbleFilter === positionKey ? null : positionKey);
      },
      size: "small",
    },
    {
      name: translation.spec,
      positionKey: PositionKey.Specialist,
      onClick: (positionKey: PositionKey) => {
        setBubbleFilter(bubbleFilter === positionKey ? null : positionKey);
      },
      size: "small",
    },
    {
      name: translation.sales,
      positionKey: PositionKey.Sales,
      onClick: (positionKey: PositionKey) => {
        setBubbleFilter(bubbleFilter === positionKey ? null : positionKey);
      },
      size: "small",
    },
  ];

  const bubbleCoordinates: BubbleGrid[] = [
    {
      size: "medium",
    },
    {
      size: "big",
    },
    {
      size: "medium",
    },
    {
      size: "big",
    },
    {
      size: "medium",
    },
    {
      size: "big",
    },
    {
      size: "big",
    },
    {
      size: "medium",
    },
  ];

  return getGridData(bubblePersonData, bubbleFilterSmall, bubbleCoordinates);
};
